import { render, staticRenderFns } from "./ListQueryRatings.vue?vue&type=template&id=79a2cc38&scoped=true"
import script from "./ListQueryRatings.vue?vue&type=script&lang=js"
export * from "./ListQueryRatings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a2cc38",
  null
  
)

export default component.exports